import { render, staticRenderFns } from "./WarehouseSelect.vue?vue&type=template&id=70dcccd0&scoped=true&"
import script from "./WarehouseSelect.vue?vue&type=script&lang=js&"
export * from "./WarehouseSelect.vue?vue&type=script&lang=js&"
import style0 from "./WarehouseSelect.vue?vue&type=style&index=0&id=70dcccd0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70dcccd0",
  null
  
)

export default component.exports